import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';
import { translationLanguageCodesSelector } from '../translation-languages/selectors';
import { Reason } from 'types';

const rootSelector = (state: RootState): State => state.Reasons;

export const statusSelector = createSelector(rootSelector, (reasons) => reasons.status);

export const errorSelector = createSelector(rootSelector, (reasons) => reasons.error);

const reasonsSelector = createSelector(rootSelector, (reasons) => reasons.data);

export const reasonsById = createSelector(
  reasonsSelector,
  (data) => (id: number) => data && data.find((dataItem) => dataItem.id === id)
);

export const reasonsWithEnabledTranslationsSelector = createSelector(
  reasonsSelector,
  translationLanguageCodesSelector,
  (reasons, translationLanguageCodes) => {
    const reasonsWithEnabledTranslations: Reason[] = reasons.map((reason) => {
      return {
        ...reason,
        translations: reason.translations.filter((translation) =>
          translationLanguageCodes.includes(translation.languageCode)
        ),
      };
    });
    return reasonsWithEnabledTranslations;
  }
);

export default {
  statusSelector,
  errorSelector,
  reasonsSelector,
  reasonsById,
  reasonsWithEnabledTranslationsSelector,
};
